import {User} from "./user";
import {Company} from "./company";

export class Invoice {
    id: string = '';
    number: string = '';
    date: string = new Date().toISOString();
    amount: number = 0;
    url: string = '';
    fattureInCloudDocumentUrl: string = '';
    fattureInCloudDocumentId?: number;
    paymentStatus: string = '';
    paymentMethod: string = '';
    status: string = '';
    companyId: string = '';
    userId: string = '';
    user: User = new User();
    company?: Company
    createdAt?: string;
    billingPeriodStart?: string;
    billingPeriodEnd?: string;
    stripeInvoiceId?: string;
    stripeBillingKind?: string;
    transactionFeeBaseAmount?: number;
    transactionFeeAmount?: number;
    transactionFeeSummary?: { baseAmount: number; feeAmount: number };

    constructor(raw?: any) {
        if (raw) {
            this.id = raw.id;
            this.number = raw.number;
            this.date = raw.date;
            this.amount = Number(raw.amount ?? 0);
            this.fattureInCloudDocumentUrl = raw.fattureInCloudDocumentUrl ?? '';
            this.fattureInCloudDocumentId = raw.fattureInCloudDocumentId;
            this.url = raw.url ?? '';
            this.paymentStatus = raw.paymentStatus;
            this.paymentMethod = raw.paymentMethod;
            this.status = raw.status;
            this.companyId = raw.companyId;
            this.userId = raw.userId;
            this.user = new User(raw.user);
            this.company = raw.company;
            this.createdAt = raw.createdAt;
            this.billingPeriodStart = raw.billingPeriodStart;
            this.billingPeriodEnd = raw.billingPeriodEnd;
            this.stripeInvoiceId = raw.stripeInvoiceId;
            this.stripeBillingKind = raw.stripeBillingKind;
            this.transactionFeeBaseAmount = Number(raw.transactionFeeBaseAmount ?? raw.transactionFeeSummary?.baseAmount ?? 0);
            this.transactionFeeAmount = Number(raw.transactionFeeAmount ?? raw.transactionFeeSummary?.feeAmount ?? 0);
            this.transactionFeeSummary = raw.transactionFeeSummary ?? {
                baseAmount: this.transactionFeeBaseAmount,
                feeAmount: this.transactionFeeAmount,
            };
        }
    }
}
